export default __webpack_public_path__ + "static/media/gallery-icon-hover.43f0cd03.svg";